<template>
  <div class="contact" id="lead">
    <h3>Contato</h3>
    <div class="success-lead" v-if="sucessLead">
      <img src="~@/assets/check-lead.svg" alt="" />
      <p>Obrigado por entrar em contato!</p>
    </div>
    <form @submit.prevent="createLead()" v-if="!sucessLead">
      <div class="input">
        <input
          type="text"
          v-model="lead.email"
          id="email"
          placeholder="E-mail"
        />
      </div>
      <div class="input">
        <input type="text" v-model="lead.name" id="name" placeholder="Nome" />
      </div>
      <div class="input">
        <the-mask
          :mask="['(##) ####-####', '(##) #####-####']"
          v-model="lead.phone_number"
          id="phone_number"
          placeholder="Telefone"
        />
      </div>
      <button type="submit" class="button-primary" :disabled="!disabledButton">
        Enviar formulário
      </button>
    </form>
    <div class="accept-terms">
      Ao enviar, você está aceitando os
      <router-link :to="{ name: 'TermsOfUse' }" exact>
        Termos e privacidade
      </router-link>
      de uso.
    </div>
  </div>
</template>

<script>
import { leadsService } from "@/services/leads.service";

export default {
  name: "ContactForm",

  data() {
    return {
      sucessLead: false,
      lead: {}
    };
  },

  computed: {
    disabledButton() {
      return this.lead.name && this.lead.email && this.lead.phone_number;
    }
  },

  methods: {
    async createLead() {
      const payload = {
        name: this.lead.name,
        phone_number: this.lead.phone_number,
        email: this.lead.email,
        building_id: this.$route.params.id
      };
      try {
        await leadsService.create(payload);
        this.sucessLead = true;
      } catch (error) {
        console.log("Ocorreu um erro inesperado.");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.contact {
  position: relative;
  width: 100%;
  display: block;
  background: var(--white);
  border: 1px solid #e5e5e5;
  border-radius: 20px;
  box-shadow: 0px 4px 20px rgba(219, 224, 230, 0.5);
  padding: 50px 50px;
  z-index: 1;

  h3 {
    font-size: var(--size-h3);
    font-weight: var(--weight-bold);
    display: block;
    line-height: 53px;
    color: var(--blue-custom);
    margin-bottom: 20px;
  }

  .success-lead {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      max-width: 110px;
      margin-bottom: 30px;
    }
  }

  .accept-terms {
    font-size: 16px;
    text-align: center;
    margin-top: 50px;

    a {
      color: var(--atomic);
      transition: color 0.2s ease-in-out;

      &:hover,
      &:active,
      &:focus {
        transition: color 0.2s ease-in-out;
        color: var(--light-blue);
      }
    }
  }

  form {
    max-width: 327px;
    width: 100%;

    input {
      height: 50px;
      display: flex;
      align-items: center;
      padding: 14px 16px;
      font-size: var(--size-base);
      color: rgba(0, 0, 0, 0.5);
      border-radius: 12px;
      border: 1px solid #e5e5e5;
      width: 100%;
      margin: 0 0 12px;
      background: var(--white);
    }

    .button-primary {
      border: none;
      border-radius: 16px;
      display: block;
      width: 100%;
      background-color: var(--blue-custom);
      margin: 24px 0 0;

      &:hover,
      &:active,
      &:focus,
      &.router-link-active {
        background: var(--light-blue);
        color: var(--white);
      }
    }
  }
}
</style>
